import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MainService } from './main.service';
import { BaseRequestBody, SuggestRequestBody, AddFriendRequestBody, Favourite, Favourites, ConfirmUser, AccountHistory, Account } from '../_models/auth.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(
    private http: HttpClient,
    private main: MainService
  ) { }

  public insertUpdate(params: BaseRequestBody) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/insert-or-update`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public merge(params: BaseRequestBody) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/merge`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public friendsList() {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/friends`, this.main.requestPreset(), { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public friendsSuggestions(params: SuggestRequestBody) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/friends/suggestions`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public inviteFriend(params: SuggestRequestBody) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/friends/invite`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public addFriend(params: AddFriendRequestBody) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/friends/add`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public shareWithFriend() {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/member-get-member/INVITATION`, this.main.requestPreset(), { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public doLogin(params: BaseRequestBody) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/login`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public doPinCheck(params: BaseRequestBody) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/login/confirm`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public doIdentityConfirm(params: ConfirmUser) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/identity-confirm`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public doIdentityConfirmation(code: string) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/identity-confirmation/${code}`, this.main.requestPreset(), { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public getAccount() {
    return this.http.get<any>(`${this.main.relativeUrl}/integrated-twt/account`, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public getProfileProps() {
    return this.http.get<any>(`${this.main.relativeUrl}/integrated-twt/account/profile-props`, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public getWallet() {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/wallet`, this.main.requestPreset(), { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public getFavourites(params?: Favourite) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/favourites`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public checkFavourites(params: { contentId: number, source: 'CMS' }) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/favourites/check`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public addFavourites(params: Favourites) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/favourites/add`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public removeFavourites(params: Favourites) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/favourites/remove`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public getAccountHistory(params: AccountHistory) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/history`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public changeHistoryStatus(params: { histId: number, histStatus: string }) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/history/change-status`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public doRecoverPass(params: Account) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/recover-password`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public confirmRecoverPass(params: { token: string, newPassword: string }) {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/recover-password/confirm`, { ...params, ...this.main.requestPreset() }, { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

  public getPopInbox() {
    return this.http.post<any>(`${this.main.relativeUrl}/integrated-twt/account/inbox`, this.main.requestPreset(), { headers: this.main.callHeaders() }).pipe(map(res => {
      return this.main.mapResponse(res);
    }));
  }

}